import React, { useContext } from 'react';
import { Pressable } from 'react-native';

import ClientContext from 'app/src/contexts/ClientContext';
import { Text } from 'app/src/styles';
import { rest } from 'app/src/utils/rest';

const generate = ({ id, credentials }) => {
  let path = 'pdf/products.pdf';

  rest({
    path,
    options: { headers: { Accept: 'application/pdf' } },
    credentials,
  }).then(response => {
    response.blob().then(blob => {
      window.open(window.URL.createObjectURL(blob));
    });
  });
};

const Products = () => {
  const { credentials } = useContext(ClientContext);

  return (
    <Pressable onPress={() => generate({ credentials })}>
      <Text>⤇ ADR Order Form</Text>
    </Pressable>
  );
};

export default Products;
